export default __webpack_public_path__ + "static/media/mr_mrs_smith_background_xl2.fd3a97cb.jpg";